import { Divider, Flex } from '@chakra-ui/react';

import SuggestRow from './SuggestRow.jsx';
import { EXCLUDED_CHILD_TYPES, EXLUDED_ENTITIES } from '#constants';
import { sameNameSelectableChild } from '../../brain/searchHierarchy.js';

export default function SuggestSection(props) {
  const { suggestion } = props;
  const { children, name: parentName, entity_type: parentType } = suggestion;
  const selectableChild = sameNameSelectableChild(suggestion, children);
  return (
    <Flex
      direction="column"
      align="stretch"
      p={1.5}
      _hover={{
        cursor: 'default',
      }}
    >
      <SuggestRow
        name={parentName}
        type={parentType}
        outing={suggestion}
        selectableOuting={selectableChild || undefined}
      />
      {!!children && (
        <Flex align="stretch" direction="column">
          {children.map((child) => {
            if (EXCLUDED_CHILD_TYPES.indexOf(child.entity_type) !== -1) {
              return null;
            }
            if (EXLUDED_ENTITIES.indexOf(child._id) !== -1) {
              return null;
            }
            return (
              <SuggestRow
                key={child._id}
                name={child.name}
                isChild
                type={child.entity_type}
                outing={child}
              />
            );
          })}
        </Flex>
      )}
    </Flex>
  );
}
